import { create } from 'zustand';

/** Orderbook built exclusively from ORDER_BOOK_DATA_DELTA messages (no snapshot).
 *  Not keyed by outcome — always reflects the latest deltas from the active subscription. */
interface OrderbookDeltasState {
  /** bids: price → size */
  bids: Map<number, number>;
  /** asks: price → size */
  asks: Map<number, number>;

  /** Apply a raw ORDER_BOOK_DATA_DELTA — upsert by price, remove if size=0 */
  pushDelta: (payload: { b?: Record<string, number>; s?: Record<string, number> }) => void;

  /** Clear all deltas */
  clear: () => void;
}

function applyLevels(
  map: Map<number, number>,
  levels: Record<string, number>,
): Map<number, number> {
  const next = new Map(map);
  for (const [priceStr, size] of Object.entries(levels)) {
    const price = Number(priceStr);
    if (size === 0) {
      next.delete(price);
    } else {
      next.set(price, size);
    }
  }
  return next;
}

export const useOrderbookDeltasStore = create<OrderbookDeltasState>()((set) => ({
  bids: new Map<number, number>(),
  asks: new Map<number, number>(),

  pushDelta: (payload) =>
    set((state) => ({
      bids: payload.b ? applyLevels(state.bids, payload.b) : state.bids,
      asks: payload.s ? applyLevels(state.asks, payload.s) : state.asks,
    })),

  clear: () =>
    set({
      bids: new Map<number, number>(),
      asks: new Map<number, number>(),
    }),
}));
